import { desmosApi } from '@/core/api/desmos'

export const {
    useCreateDesmosActMutation,
    useGetDesmosPatientQuery,
    useLazyGetDesmosPatientQuery,
} = desmosApi

